import React, { useCallback } from 'react';

//external packages
import styled from 'styled-components';
import { format } from 'date-fns';
import { Col, Text, Row } from '@cuemath/comps';
import { Block } from 'styled-icons/boxicons-regular/Block';
import { Class } from 'styled-icons/material/Class';
import { Stop } from 'styled-icons/octicons/Stop';

//components
import Link from 'comps/link';
import BallLoader from 'comps/ball-loader';

//constants
import { PRE_CLASS_SCREEN_MAX_TIME } from 'constants/av-player';

const BlockIcon = styled(Block)`
  width: 20px;
  height: 20px;
  color: red;
  font-weight: bold;
`;

const ClassIcon = styled(Class)`
  width: 20px;
  height: 20px;
  color: black;
  font-weight: bold;
`;

const StopIcon = styled(Stop)`
  width: 20px;
  height: 20px;
  color: red;
  font-weight: bold;
`;
const WarningText = styled(Text)`
  font-family: 'Untitled Sans Regular', sans-serif !important;
  font-size: 16px;
  font-style: italic;
  font-weight: 600;
  line-height: 24px;
  margin-left: 5px;
  width: 400px;
`;

const FallbackScreen = ({
  teacherClassroomId,
  classStatus,
  classStatusFailed,
  classStatusLoading,
}) => {
  const {
    class_start_delta_time: deltaStartTime,
    scheduled_start_datetime: meetingStartTime,
    scheduled_end_datetime: scheduledEndTime,
    rm_call_enabled: isRMCallEnabled,
  } = classStatus;

  const isMeetingOver = useCallback(() => {
    return scheduledEndTime <= new Date().getTime() / 1000;
  }, [scheduledEndTime]);

  const renderContent = () => {
    if (!meetingStartTime || classStatusFailed) {
      return (
        <Row>
          <BlockIcon />
          <WarningText size="normal">Please use valid Teacher-Classroom-Id</WarningText>
        </Row>
      );
    }
    if (!isRMCallEnabled) {
      return (
        <Row>
          <BlockIcon />
          <ScreenContext>
            This call is not 3-way call enabled so AC can't join this call.
          </ScreenContext>
        </Row>
      );
    }

    if (deltaStartTime < 0) {
      return (
        <Row>
          <StopIcon />
          <ScreenContext>Class is over for meeting id {teacherClassroomId}</ScreenContext>
        </Row>
      );
    }

    if (deltaStartTime && deltaStartTime > PRE_CLASS_SCREEN_MAX_TIME) {
      const time = format(meetingStartTime * 1000, 'HH:mm A');
      const date = format(meetingStartTime * 1000, 'YYYY-MM-DD');

      return (
        <Row>
          <ClassIcon />
          <ScreenContext>
            This meeting will take place at: Time: {time}, Date: {date}
          </ScreenContext>
        </Row>
      );
    }
  };

  if (!classStatusFailed && (classStatusLoading || !isMeetingOver())) {
    return (
      <FallbackScreen.wrapper>
        <ScreenContext>
          <Col>
            <BallLoader />
            <LoadingText size="medium">Loading...</LoadingText>
          </Col>
        </ScreenContext>
      </FallbackScreen.wrapper>
    );
  }

  return (
    <FallbackScreen.wrapper>
      {renderContent()}
      <ScreenFooter>
        For more details you can check{' '}
        <Link to={`/users/teacher-classroom/${teacherClassroomId}`}>
          Meeting Review Page
        </Link>
      </ScreenFooter>
    </FallbackScreen.wrapper>
  );
};

export default FallbackScreen;

const LoadingText = styled(Text)`
  margin-top: 5px;
  font-weight: bold;
  color: #2b2b2b;
`;

FallbackScreen.wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 200px;
  font-family: 'Untitled Sans Regular', sans-serif !important;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #2b2b2b;
  font-style: normal;
`;

const ScreenContext = styled.div`
  font-family: 'Untitled Sans Regular', sans-serif !important;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #2b2b2b;
  font-style: normal;
  padding-left: 10px;
  a {
    cursor: pointer;
  }
`;

const ScreenFooter = styled(ScreenContext)`
  font-weight: 400;
  margin-top: 10px;
`;
